import Icon from './Icon';
import { products } from '../constants/content';
import { SUPPORT_PHONE_TEL } from '../constants/site';

export default function Products() {
  return (
    <section className="section" id="products">
      <div className="container">
        <div className="sec-head sec-head--center">
          <p className="kicker">Explore Our Products</p>
          <h2 className="sec-title">Genuine McAfee Licences</h2>
          <p className="sec-lead">
            Digital delivery within minutes of checkout. Every key is sourced through authorised
            distribution and backed by our 30-day guarantee.
          </p>
        </div>

        <div className="product-grid">
          {products.map((product) => (
            <a
              key={product.name}
              href={`tel:${SUPPORT_PHONE_TEL}`}
              className="product"
              aria-label={`${product.name} — call to order`}
            >
              <div className={`product__art product__art--${product.tone}`}>
                {product.tag && <span className="product__tag">{product.tag}</span>}
                <div className="product__box">
                  <span className="product__box-mark">
                    <Icon name="shield" size={18} fill />
                  </span>
                  <span className="product__box-name">{product.name}</span>
                  <span className="product__box-bar" />
                </div>
              </div>

              <div className="product__body">
                <h3 className="product__name">{product.name}</h3>
                <p className="product__sub">{product.subtitle}</p>
                <p className="product__price">
                  <span className="product__amount">${product.price}</span>
                  <span className="product__strike">${product.strike}</span>
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
